export const COLOR = {
  WHITESMOKE: "#E5E5E5",
  DARK: "#6b7280",
  PRIMARY: "#1F9096",
  SECONDARY: "#26AFB6",
  WARNING: "#e3342f",
  SUCCESS: "#16c79a",
  INFO: "#FF7E67",
};

export const BACKEND_URL = {
  AVATAR: `${process.env.REACT_APP_SERVER_URI}/img/avatar`,
};

export const IMAGE = {
  SIZE_LIMIT: 1 * 1024 * 1024,
};

export const CATEGORY = {
  doctor: "Dokter",
  "health worker": "Petugas Medis",
  superuser: "admin",
};

export const VARIABLE = {
  basic: [
    { key: "RR", label: "RR" },
    { key: "SPO2", label: "SPO2" },
    { key: "T", label: "Temperatur" },
    { key: "HR", label: "Heart rate" },
  ],
  spirometer: [],
};

export const GRAPH_COLOR = [
  "#f05454",
  "#16c79a",
  "#8884d8",
  "#00bcd4",
  "#845ec2",
  "#C84B31",
  "#E5D549",
  "#206A5D",
];

export const VAR_LIMIT = {
  weight: {
    min: 0,
    max: 300,
  },
  height: {
    min: 0,
    max: 300,
  },
  age: {
    max: 150,
  },
};

export const RESPINOS_LINK = {
  android: "https://play.google.com/store/apps/details?id=com.xirka.vo2",
};
